export default () => ({
  el: undefined,
  init() {
    mrp.log(`RxDataGrid init`);
    this.el = this.$el;
    const id = this.el.getAttribute("data-id");
    const endpoint = this.el.getAttribute("data-endpoint");
    const useInfiniteScroll = this.el.getAttribute("data-use-infinite-scroll");
    if (useInfiniteScroll === "true") {
      sessionStorage.removeItem(`${id}-page`);
    }
    const filter = sessionStorage.getItem(`${id}-filter`) ?? "";
    const sort = sessionStorage.getItem(`${id}-sort`) ?? "";
    const context = sessionStorage.getItem(`${id}-context`) ?? "";
    let page =
      useInfiniteScroll === "true"
        ? "1"
        : sessionStorage.getItem(`${id}-page`) ?? "1";
    if (page.trim() === "") {
      page = "1";
    }
    const route = `${endpoint}/${page}?${sort}&${filter}&${context}`;
    this.el.setAttribute("hx-get", route);
    htmx.process(this.el);
  },
});
